<template>
  <div id="Enterstd_rec">
    <div class="login-page">
      <transition name="fade">
        <div v-if="!status" class="wallpaper-login"></div>
      </transition>
      <div class="wallpaper-register"></div>

      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-8 mx-auto">
            <div
              id="login-card"
              class="card login"
              v-if="!status && !status_success"
            >
              <h1>Recording_{{ room_number }}</h1>
              <form class="form-group" @submit.prevent="verify">
                <input
                  v-model="std_code"
                  type="text"
                  class="form-control input-style"
                  placeholder="กรอกรหัสนักศึกษา/รหัสอาจารย์เพื่อยืนยัน"
                  required
                />
                <button
                  id="button"
                  type="submit"
                  class="btn btn-success deep-purple btn-block"
                >
                  ตรวจสอบ
                </button>
              </form>
            </div>

            <div
              id="locker-card"
              class="card login"
              v-if="status && !status_success"
            >
              <h3 v-if="histories.length === 0">{{ message }}</h3>
              <span v-if="histories.length !== 0">
                <h4 class="">รายละเอียดการจอง</h4>
                <div
                  class="text-left"
                  v-for="(item, index) in histories"
                  :key="index"
                >
                  <span>
                    <b>ห้องที่จอง :</b>{{ item.room_name }} [
                    {{ item.room_desc }}]
                  </span>
                  <br />
                  <span> <b>ชื่อผู้จอง : </b>{{ item.whois_std_name }} </span>
                  <br />
                  <span> <b>วัตถุประสงค์ :</b> {{ item.usefor_name }} </span>
                  <br />
                  <span>
                    <b>เวลาจอง : </b>{{ item.time_begin }} - {{ item.time_end }}
                  </span>
                  <br />
                  <span>วันที่จอง : {{ item.meeting_date | moment }}</span>
                  <br />
                  <br />
                  <button
                    id="button"
                    class="btn btn-outline-info deep-purple btn-block"
                    @click="confirms(item.order_id)"
                  >
                    ยืนยันการใช้งาน
                  </button>
                </div>
              </span>
            </div>
            <div id="locker-card" class="card login" v-if="status_success">
              <h4>ยืนยันการจองห้องเรียบร้อย</h4>
              <img
                src="../../assets/icons/success.gif"
                class="rounded mx-auto d-block"
                alt=""
                width="60%"
                height="auto"
              />
              <router-link
                to="/BookingRoom"
                class="btn btn-outline-info badge-pill"
                size="lg"
              >
                เสร็จสิ้น
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "Enterstd_rec",
  data() {
    return {
      std_code: "",
      room_number: "",
      tokenjong: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      status: false,
      password: "",
      histories: [],
      staff: "",
      isShowstaff: false,
      auth: "",
      message: "",
      status_success: false,
      code: "",
    };
  },
  filters: {
    moment: function(date) {
      moment.locale("th");
      return moment(date)
        .add(543, "year")
        .format("LL");
    },
  },
  mounted() {
    this.room_number = this.$route.params.id;
    if (localStorage.getItem("auth") != null) {
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;
    }
  },


  methods: {
    verify() {
      let data = {
        std_code: this.std_code,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/verify ", data, {
          headers,
        })
        .then((res) => {

          if (res.data.msg.status !== 200) {
            this.message = res.data.msg.message;
            this.status = true;
            this.$isLoading(false);
          } else {
            this.status = true;
            this.histories = res.data.histories;
            this.$isLoading(false);
            localStorage.setItem("lockerpass", JSON.stringify(this.password));
          }
        });
    },
    confirms(id) {
      let data = {
        order_id: id,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/confirm ", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status !== 200) {
            this.message = res.data.msg.message;
            this.$isLoading(false);
            this.status = true;
          } else {
            this.$isLoading(false);
            this.status = true;
            this.status_success = true;
          }
        });
    },
  },
};
</script>

<style scoped>
#button {
  border-radius: 30px;
}

.input-style {
  border-radius: 30px;
  background-color: #ebf0fc;
  border-color: #ebf0fc;
  color: #9da3b0;
}
#login-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}
#locker-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}
#regis-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}

p {
  line-height: 1rem;
}

.card {
  padding: 20px;
}

.form-group input {
  margin-bottom: 20px;
}
.form-group button {
  margin-bottom: 20px;
}

.login-page {
  align-items: center;
  display: flex;
  height: 100vh;
}
.login-page .wallpaper-login {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  background: -webkit-linear-gradient(-55deg, #754bd4 40%, #2ba3be 100%)
    no-repeat center center;
  background-size: cover;
  height: 100%;
  position: absolute;
  width: 100%;
}

.login-page .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.wallpaper-register {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  background-size: cover;
  background: -webkit-linear-gradient(-55deg, #2ba3be 40%, #754bd4 100%)
    no-repeat center center;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
}

h1 {
  margin-bottom: 1.5rem;
}

.error {
  animation-name: errorShake;
  animation-duration: 0.3s;
}

@keyframes errorShake {
  0% {
    transform: translateX(-25px);
  }
  25% {
    transform: translateX(25px);
  }
  50% {
    transform: translateX(-25px);
  }
  75% {
    transform: translateX(25px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
